import { useAtomValue } from 'jotai';
import { FormattedMessage } from 'react-intl';

import { useIsAppsLowDiskWarningDesktopEnabled } from '@/app-shell/flags/desktop-flags';
import { lowDiskSpaceAtom } from '@/atoms/lowDiskSpaceAtom';
import { isTauri } from '@/tauri/utils';
import {
  Banner,
  BannerContent,
  BannerDescription,
  BannerTitle,
} from '@heidi/design-system/banner';
import { activeSessionIdAtom } from '@heidi/session/data';

/**
 * Presentational banner — pure props, no atom or Tauri dependency. The warning
 * tone communicates that capture is still running but needs user attention.
 */
export const LowDiskAlertView = () => (
  <Banner
    subVariant="warning"
    role="status"
    aria-live="polite"
    data-testid="low-disk-alert"
    className="shrink-0"
  >
    <BannerContent>
      <BannerTitle>
        <FormattedMessage
          defaultMessage="Your device is low on storage."
          id="5A8Fbt9RGw"
        />
      </BannerTitle>
      <BannerDescription>
        <FormattedMessage
          defaultMessage="Free up space soon to avoid interrupting your session."
          id="5P9ly8bHPR"
        />
      </BannerDescription>
    </BannerContent>
  </Banner>
);

/**
 * Low-disk-space warning banner for active desktop captures.
 */
export const LowDiskAlert = () => {
  const isLowDiskWarningEnabled = useIsAppsLowDiskWarningDesktopEnabled();
  const warning = useAtomValue(lowDiskSpaceAtom);
  const activeSessionId = useAtomValue(activeSessionIdAtom);

  if (!isLowDiskWarningEnabled || !isTauri()) return null;
  if (!warning || warning.sessionId !== activeSessionId) return null;

  return <LowDiskAlertView />;
};
